import List from "@/components/List";
import ListRow from "@/components/Row/ListRow/index";
import { useTvShowEpisodesQuery } from "@/hooks";
import { LIST_PAGE_LIMIT } from "@/lib/constants";
import { useMemo } from "react";

export default function TvShowEpisodesList({ id, showHeader = false }) {
  const { data, ...result } = useTvShowEpisodesQuery({
    variables: { id, offset: 0, limit: LIST_PAGE_LIMIT },
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
  });
  const items = data?.children;

  const header = useMemo(() => {
    if (showHeader) {
      return { text: "エピソード一覧" };
    } else {
      return null;
    }
  }, [showHeader]);

  return (
    <List
      {...result}
      itemComponent={ListRow}
      header={header}
      items={items}
      limit={LIST_PAGE_LIMIT}
      viewTypeClassName="list"
    />
  );
}
